import type { Subject } from '../../types';

// Mock subjects data with codes, exam codes, and categories
// Comprehensive UK secondary school curriculum

export const mockSubjects: Subject[] = [
  // Core Subjects - Mathematics
  {
    id: 'subject-math',
    name: 'Mathematics',
    code: 'MATH',
    examCode: 'GCSE 8300',
    category: 'stem',
    color: '#1976d2',
    department: 'Mathematics',
  },
  {
    id: 'subject-math-alevel',
    name: 'A-Level Mathematics',
    code: 'MATH-AL',
    examCode: 'A-Level 9709',
    category: 'stem',
    color: '#1565c0',
    department: 'Mathematics',
  },
  {
    id: 'subject-further-math',
    name: 'Further Mathematics',
    code: 'FMATH',
    examCode: 'A-Level 9231',
    category: 'stem',
    color: '#0d47a1',
    department: 'Mathematics',
  },

  // Core Subjects - English
  {
    id: 'subject-english-lang',
    name: 'English Language',
    code: 'ENG-L',
    examCode: 'GCSE 8700',
    category: 'core',
    color: '#388e3c',
    department: 'English',
  },
  {
    id: 'subject-english-lit',
    name: 'English Literature',
    code: 'ENG-LIT',
    examCode: 'GCSE 8702',
    category: 'core',
    color: '#2e7d32',
    department: 'English',
  },
  {
    id: 'subject-english-alevel',
    name: 'A-Level English Literature',
    code: 'ENG-AL',
    examCode: 'A-Level 9695',
    category: 'core',
    color: '#1b5e20',
    department: 'English',
  },

  // Sciences
  {
    id: 'subject-biology',
    name: 'Biology',
    code: 'BIO',
    examCode: 'GCSE 8461',
    category: 'stem',
    color: '#689f38',
    department: 'Science',
  },
  {
    id: 'subject-chemistry',
    name: 'Chemistry',
    code: 'CHEM',
    examCode: 'GCSE 8462',
    category: 'stem',
    color: '#f57c00',
    department: 'Science',
  },
  {
    id: 'subject-physics',
    name: 'Physics',
    code: 'PHY',
    examCode: 'GCSE 8463',
    category: 'stem',
    color: '#7b1fa2',
    department: 'Science',
  },
  {
    id: 'subject-combined-science',
    name: 'Combined Science',
    code: 'SCI',
    examCode: 'GCSE 8464',
    category: 'stem',
    color: '#558b2f',
    department: 'Science',
  },
  {
    id: 'subject-biology-alevel',
    name: 'A-Level Biology',
    code: 'BIO-AL',
    examCode: 'A-Level 9700',
    category: 'stem',
    color: '#33691e',
    department: 'Science',
  },
  {
    id: 'subject-chemistry-alevel',
    name: 'A-Level Chemistry',
    code: 'CHEM-AL',
    examCode: 'A-Level 9701',
    category: 'stem',
    color: '#e65100',
    department: 'Science',
  },
  {
    id: 'subject-physics-alevel',
    name: 'A-Level Physics',
    code: 'PHY-AL',
    examCode: 'A-Level 9702',
    category: 'stem',
    color: '#4a148c',
    department: 'Science',
  },

  // Humanities
  {
    id: 'subject-history',
    name: 'History',
    code: 'HIST',
    examCode: 'GCSE 8145',
    category: 'humanities',
    color: '#5d4037',
    department: 'Humanities',
  },
  {
    id: 'subject-geography',
    name: 'Geography',
    code: 'GEOG',
    examCode: 'GCSE 8035',
    category: 'humanities',
    color: '#0097a7',
    department: 'Humanities',
  },
  {
    id: 'subject-history-alevel',
    name: 'A-Level History',
    code: 'HIST-AL',
    examCode: 'A-Level 9489',
    category: 'humanities',
    color: '#3e2723',
    department: 'Humanities',
  },
  {
    id: 'subject-geography-alevel',
    name: 'A-Level Geography',
    code: 'GEOG-AL',
    examCode: 'A-Level 9696',
    category: 'humanities',
    color: '#006064',
    department: 'Humanities',
  },

  // Languages
  {
    id: 'subject-french',
    name: 'French',
    code: 'FRE',
    examCode: 'GCSE 8658',
    category: 'languages',
    color: '#c2185b',
    department: 'Languages',
  },
  {
    id: 'subject-spanish',
    name: 'Spanish',
    code: 'SPA',
    examCode: 'GCSE 8698',
    category: 'languages',
    color: '#d32f2f',
    department: 'Languages',
  },
  {
    id: 'subject-german',
    name: 'German',
    code: 'GER',
    examCode: 'GCSE 8668',
    category: 'languages',
    color: '#7b1fa2',
    department: 'Languages',
  },

  // Arts
  {
    id: 'subject-art',
    name: 'Art & Design',
    code: 'ART',
    examCode: 'GCSE 8201',
    category: 'arts',
    color: '#e91e63',
    department: 'Arts',
  },
  {
    id: 'subject-music',
    name: 'Music',
    code: 'MUS',
    examCode: 'GCSE 8271',
    category: 'arts',
    color: '#9c27b0',
    department: 'Arts',
  },
  {
    id: 'subject-drama',
    name: 'Drama',
    code: 'DRA',
    examCode: 'GCSE 8261',
    category: 'arts',
    color: '#673ab7',
    department: 'Arts',
  },

  // Technology & Computing
  {
    id: 'subject-computer-science',
    name: 'Computer Science',
    code: 'CS',
    examCode: 'GCSE 8525',
    category: 'stem',
    color: '#00796b',
    department: 'Technology',
  },
  {
    id: 'subject-dt',
    name: 'Design Technology',
    code: 'DT',
    examCode: 'GCSE 8552',
    category: 'practical',
    color: '#455a64',
    department: 'Technology',
  },
  {
    id: 'subject-cs-alevel',
    name: 'A-Level Computer Science',
    code: 'CS-AL',
    examCode: 'A-Level 9618',
    category: 'stem',
    color: '#004d40',
    department: 'Technology',
  },

  // Physical Education
  {
    id: 'subject-pe',
    name: 'Physical Education',
    code: 'PE',
    examCode: 'GCSE 8582',
    category: 'pe',
    color: '#f57f17',
    department: 'PE',
  },
  {
    id: 'subject-pe-alevel',
    name: 'A-Level PE',
    code: 'PE-AL',
    examCode: 'A-Level 9396',
    category: 'pe',
    color: '#f57f17',
    department: 'PE',
  },

  // Business & Economics
  {
    id: 'subject-business',
    name: 'Business Studies',
    code: 'BUS',
    examCode: 'GCSE 8132',
    category: 'elective',
    color: '#6a1b9a',
    department: 'Business',
  },
  {
    id: 'subject-economics-alevel',
    name: 'A-Level Economics',
    code: 'ECO-AL',
    examCode: 'A-Level 9708',
    category: 'elective',
    color: '#4a148c',
    department: 'Business',
  },

  // Religious Studies
  {
    id: 'subject-rs',
    name: 'Religious Studies',
    code: 'RS',
    examCode: 'GCSE 8062',
    category: 'humanities',
    color: '#ad1457',
    department: 'Humanities',
  },
];

// Helper functions
export const getSubjectByCode = (code: string): Subject | undefined => {
  return mockSubjects.find((s) => s.code === code);
};

export const getSubjectsByCategory = (category: Subject['category']): Subject[] => {
  return mockSubjects.filter((s) => s.category === category);
};

export const getSubjectsByDepartment = (department: string): Subject[] => {
  return mockSubjects.filter((s) => s.department === department);
};

export const getCoreSubjects = (): Subject[] => {
  return mockSubjects.filter(
    (s) => s.category === 'core' || s.code.includes('MATH') || s.code.includes('ENG') || s.code.includes('SCI'),
  );
};

export const getElectiveSubjects = (): Subject[] => {
  return mockSubjects.filter((s) => !getCoreSubjects().includes(s));
};
